var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZapFormBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1100,
    height: 426,
    viewBox: "0 0 1100 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_26_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.323 255.138C620.907 251.616 834.315 241.817 926.405 264.57C1018.81 287.399 812.508 309.203 783.317 334.941C755.523 359.447 874.761 389.644 765.394 406.534C635.258 426.631 411.367 433.241 245.029 418.07C85.7132 403.54 66.1612 369.501 44.4389 340.78C27.9817 319.021 61.2599 298.394 141.948 281.778C219.162 265.877 333.565 257.919 460.323 255.138Z",
    fill: "#20D5FC",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_26_1955",
    x: -208.936,
    y: 0.719742,
    width: 1408.26,
    height: 674.947,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 124.64,
    result: "effect1_foregroundBlur_26_1955"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapFormBackground);
export default __webpack_public_path__ + "static/media/zap-form-background.c13f0c5d0fb5e59f904c4b412d265330.svg";
export { ForwardRef as ReactComponent };